// extracted by mini-css-extract-plugin
module.exports = {"slider":"Slider_slider__29fPg","sliderValues":"Slider_sliderValues__S9iTM","sliderValue":"Slider_sliderValue__1DXSN"};